import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import Projects from '../pages/projects/index';
import ProjectsArchived from '../pages/projects/archived';
import ProjectNew from '../pages/projects/new';
import ProjectShow from '../pages/projects/show';
import ProjectEdit from '../pages/projects/edit';
import ProjectFiles from '../pages/projects/files';
import ProjectInitiatives from '../pages/projects/initiatives.jsx';

export const projectRoutes = () => (
  <>
    <Route path={ROUTES.PROJECTS_INDEX} element={<Projects />} />
    <Route path={ROUTES.PROJECTS_ARCHIVED} element={<ProjectsArchived />} />
    <Route path={ROUTES.PROJECTS_NEW} element={<ProjectNew />} />
    <Route path={ROUTES.PROJECTS_SHOW} element={<ProjectShow />} />
    <Route path={ROUTES.PROJECTS_EDIT} element={<ProjectEdit />} />
    <Route path={ROUTES.PROJECTS_FILES} element={<ProjectFiles />} />
    <Route
      path={ROUTES.PROJECTS_INITIATIVES}
      element={<ProjectInitiatives />}
    />
  </>
);
